/* Cart Qty Warning (no-liquid version)
   - Works on cart page only
   - Fetches /cart.js and /products/{handle}.js
   - Injects warnings near each line item's quantity
*/
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  function init() {
    if (!/\/cart(\/|$|\?)/.test(location.pathname)) return;

    injectBaseStyles();

    // Build once, reuse product JSON by handle
    var productCache = Object.create(null);

    fetchJSON('/cart.js').then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) return;

      // Process all items -> for each, ensure product JSON loaded
      var promises = cart.items.map(function (item) {
        var handle = item.handle || item.product_handle;
        if (!handle) return Promise.resolve({ item: item, product: null });

        if (!productCache[handle]) {
          productCache[handle] = fetchJSON('/products/' + encodeURIComponent(handle) + '.js')
            .catch(function(){ return null; });
        }
        return productCache[handle].then(function (product) {
          return { item: item, product: product };
        });
      });

      Promise.all(promises).then(function (pairs) {
        pairs.forEach(function (pair) { tryRenderWarning(pair.item, pair.product); });
        // Bind listeners for qty changes / cart updates
        hookQuantityChanges(pairs);
      });
    }).catch(function(){ /* ignore */ });
  }

  // -------------- helpers --------------
  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  function injectBaseStyles() {
    if (document.getElementById('tw-cart-qty-warning-style')) return;
    var css = [
      '.tw-qty-warning{margin-top:8px;padding:10px 12px;border-radius:6px;font-size:14px;line-height:1.5;',
      'background:#fff7e6;color:#8a5a00;border:1px solid rgba(138,90,0,.2)}',
      '.tw-qty-warning a{color:inherit;text-decoration:underline}',
      '.tw-qty-warning[hidden]{display:none!important}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'tw-cart-qty-warning-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function findLineItemContainer(item) {
    // Try common Online Store 2.0 selectors, then fallbacks
    var keySel = '[data-cart-item-key="' + cssEscape(item.key) + '"]';
    var byKey = document.querySelector(keySel);
    if (byKey) return byKey;

    var byVariant = document.querySelector('[data-variant-id="' + item.variant_id + '"]');
    if (byVariant) return byVariant.closest('[data-cart-item], .cart__row, .cart-item') || byVariant;

    // Dawn/others often have ids like CartItem-<index> or data-id attr
    var byIndex = document.querySelector('#CartItem-' + item.key) || document.querySelector('[data-id="' + item.key + '"]');
    if (byIndex) return byIndex;

    // As a last resort, return the first row
    return document.querySelector('[data-cart-item], .cart__row, .cart-item') || document.querySelector('form[action*="/cart"]');
  }

  function findQtyParent(container) {
    if (!container) return null;
    // Try to anchor warning near the quantity control
    return container.querySelector('[name="updates[]"], input[name^="updates"], .quantity, .cart-item__quantity') || container;
  }

  function getVariantInventory(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    var v = product.variants.find(function (vv) { return Number(vv.id) === Number(variantId); });
    if (!v) return null;
    // Some themes expose inventory_quantity; if missing, treat as 0
    return {
      qty: Number(v.inventory_quantity != null ? v.inventory_quantity : 0),
      policy: String(v.inventory_policy || 'deny'),
      available: !!v.available
    };
  }

  function buildMessage(desired, available) {
    var extra = desired - available;
    function p(n, one, many){ return n===1?one:many; }
    return 'You’re requesting <strong>' + desired + '</strong>, but only <strong>' + available + ' ' +
      p(available,'item','items') + '</strong> are in stock. The extra <strong>' + extra + ' ' +
      p(extra,'item','items') + '</strong> will be placed on back order. We’ll ship your order in full once everything is available. ' +
      'Prefer a split shipment? <a href="mailto:sales@testallwater.co.uk">Email us</a> or call <a href="tel:+441158882726">+44 (0)115 888 2726</a>.';
  }

  function renderOrUpdateWarning(container, key, html) {
    var id = 'tw-qty-warning-' + key;
    var box = document.getElementById(id);
    if (!box) {
      box = document.createElement('div');
      box.id = id;
      box.className = 'tw-qty-warning';
      box.setAttribute('aria-live', 'polite');
      var anchor = findQtyParent(container);
      (anchor || container).appendChild(box);
    }
    if (html) {
      box.innerHTML = html;
      box.hidden = false;
    } else {
      box.hidden = true;
      box.innerHTML = '';
    }
  }

  function tryRenderWarning(item, product) {
    var container = findLineItemContainer(item);
    if (!container) return;

    var inv = getVariantInventory(product, item.variant_id);

    // If we couldn't resolve inventory, fail silently (no warning)
    if (!inv) { renderOrUpdateWarning(container, item.key, ''); return; }

    var desired = Number(item.quantity || 1);
    var available = Number(inv.qty || 0);

    // Continue selling without warning? (set to true if you want to suppress warnings)
    var ALLOW_BACKORDER_WITHOUT_WARNING = false;

    if (ALLOW_BACKORDER_WITHOUT_WARNING && inv.policy === 'continue' && available <= 0) {
      renderOrUpdateWarning(container, item.key, '');
      return;
    }

    if (desired > available) {
      renderOrUpdateWarning(container, item.key, buildMessage(desired, available));
    } else {
      renderOrUpdateWarning(container, item.key, '');
    }
  }

  function hookQuantityChanges(pairs) {
    // Re-check when quantities are changed or cart updates
    ['change', 'input', 'click', 'submit'].forEach(function (ev) {
      document.addEventListener(ev, debounce(function () {
        // Refresh cart quantities (safer than guessing)
        fetchJSON('/cart.js').then(function (cart) {
          var map = Object.create(null);
          cart.items.forEach(function (i) { map[i.key] = i; });

          pairs.forEach(function (pair) {
            var latest = map[pair.item.key] || pair.item;
            pair.item = latest;
            tryRenderWarning(pair.item, pair.product);
          });
        }).catch(function(){});
      }, 300), true);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function(){ fn.apply(ctx, args); }, wait);
    };
  }

  // CSS.escape polyfill-ish
  function cssEscape(str){
    try { return CSS.escape(str); } catch(e) {
      return String(str).replace(/[^a-zA-Z0-9_-]/g,'\\$&');
    }
  }
})();
